import { Component, computed, input, InputSignal, Signal } from '@angular/core';
import { ApplicationAppEntityApplicationRead } from '../../../../../../../openapi';
import { AlertComponent } from '../../../../../../../common/alert/alert.component';

@Component({
  selector: 'app-attachment-info',
  standalone: true,
  imports: [
    AlertComponent
  ],
  templateUrl: './attachment-info.component.html'
})
export class AttachmentInfoComponent {
  public application: InputSignal<ApplicationAppEntityApplicationRead | null> = input<ApplicationAppEntityApplicationRead | null>(null);

  public get stumpDutyInfo(): Signal<boolean> {
    return computed(() => {
      const app = this.application();
      return !(app?.attachments?.map(v => v?.attachment?.tag || '') || []).includes('OplataSkarbowa')
        &&
        [
          '/wypis-i-wyrys-z-mpzp',
          '/wypis-i-wyrys-ze-studium',
          '/zaswiadczenie-z-mpzp',
          '/zaswiadczenie-ze-studium'
        ].includes(app?.service?.url as string);
    });
  }

}
